// extracted by mini-css-extract-plugin
export default {"counterRoot":"qc8UlY"};